<template>
  <div class="region-selector-mobile">
    <div class="px-1">
      <p class="text-xs font-medium text-gray-400 uppercase tracking-wide mb-3 text-center">
        Región / Region
      </p>
      
      <!-- Botones verticales con descripción -->
      <div class="flex flex-col gap-2">
        <!-- Opción España -->
        <button
          @click="changeRegion('es')"
          class="flex items-center justify-between p-3 rounded-lg transition-all duration-200"
          :class="regionId === 'es' 
            ? 'bg-indigo-50 border-2 border-indigo-500' 
            : 'bg-white border-2 border-gray-200 hover:border-gray-300'"
        >
          <div class="flex items-center gap-3">
            <span class="text-3xl">🇪🇸</span>
            <div class="text-left">
              <div 
                class="text-sm font-semibold"
                :class="regionId === 'es' ? 'text-indigo-700' : 'text-gray-900'"
              >
                España
              </div>
              <div class="text-xs text-gray-500">Madrid, Barcelona, Valencia...</div>
            </div>
          </div>
          <svg 
            v-if="regionId === 'es'"
            class="w-5 h-5 text-indigo-600 flex-shrink-0" 
            fill="currentColor" 
            viewBox="0 0 20 20"
          >
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
        </button>

        <!-- Opción United States (New York) -->
        <button
          @click="changeRegion('us')"
          class="flex items-center justify-between p-3 rounded-lg transition-all duration-200"
          :class="regionId === 'us' 
            ? 'bg-indigo-50 border-2 border-indigo-500' 
            : 'bg-white border-2 border-gray-200 hover:border-gray-300'"
        >
          <div class="flex items-center gap-3">
            <span class="text-3xl">🇺🇸</span>
            <div class="text-left">
              <div 
                class="text-sm font-semibold"
                :class="regionId === 'us' ? 'text-indigo-700' : 'text-gray-900'"
              >
                United States
              </div>
              <div class="text-xs text-gray-500">New York</div>
            </div>
          </div>
          <svg 
            v-if="regionId === 'us'"
            class="w-5 h-5 text-indigo-600 flex-shrink-0" 
            fill="currentColor" 
            viewBox="0 0 20 20"
          >
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
        </button>

        <!-- Opción United Kingdom (London) -->
        <button
          @click="changeRegion('uk')"
          class="flex items-center justify-between p-3 rounded-lg transition-all duration-200"
          :class="regionId === 'uk' 
            ? 'bg-indigo-50 border-2 border-indigo-500' 
            : 'bg-white border-2 border-gray-200 hover:border-gray-300'"
        >
          <div class="flex items-center gap-3">
            <span class="text-3xl">🇬🇧</span>
            <div class="text-left">
              <div 
                class="text-sm font-semibold"
                :class="regionId === 'uk' ? 'text-indigo-700' : 'text-gray-900'"
              >
                United Kingdom
              </div>
              <div class="text-xs text-gray-500">London</div>
            </div>
          </div>
          <svg 
            v-if="regionId === 'uk'"
            class="w-5 h-5 text-indigo-600 flex-shrink-0" 
            fill="currentColor" 
            viewBox="0 0 20 20"
          >
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
        </button>
      </div>

      <!-- Separador -->
      <div class="h-px bg-gray-200 my-4"></div>

      <!-- Selector de Idioma -->
      <div>
        <p class="text-xs font-medium text-gray-400 uppercase tracking-wide mb-3 text-center">
          {{ currentLocale === 'es' ? 'Idioma / Language' : 'Language / Idioma' }}
        </p>
        
        <div class="flex items-center justify-center gap-6">
          <!-- Opción Español -->
          <button
            @click="changeLanguage('es')"
            class="flex flex-col items-center gap-1 px-2 py-1.5 transition-all duration-200 group"
            :class="currentLocale === 'es' 
              ? 'text-indigo-600' 
              : 'text-gray-500 hover:text-gray-700'"
          >
            <span class="text-2xl">🇪🇸</span>
            <span class="text-xs font-medium">Español</span>
            <div 
              class="h-0.5 w-full rounded-full transition-all duration-200"
              :class="currentLocale === 'es' ? 'bg-indigo-600' : 'bg-transparent group-hover:bg-gray-300'"
            ></div>
          </button>

          <!-- Opción English -->
          <button
            @click="changeLanguage('en')"
            class="flex flex-col items-center gap-1 px-2 py-1.5 transition-all duration-200 group"
            :class="currentLocale === 'en' 
              ? 'text-indigo-600' 
              : 'text-gray-500 hover:text-gray-700'"
          >
            <span class="text-2xl">🇬🇧</span>
            <span class="text-xs font-medium">English</span>
            <div 
              class="h-0.5 w-full rounded-full transition-all duration-200"
              :class="currentLocale === 'en' ? 'bg-indigo-600' : 'bg-transparent group-hover:bg-gray-300'"
            ></div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRegion } from '@/composables/useRegion'
import { useAnalytics } from '@/composables/useAnalytics'
import Trans from '@/i18n/translation'

// Definir emit para cerrar el menú móvil después de cambiar región
const emit = defineEmits(['regionChanged'])

// Composable de región
const { 
  regionId, 
  regionName,
  setRegion,
  initializeRegion
} = useRegion()

// Composable de analytics
const { track } = useAnalytics()

// Idioma actual
const currentLocale = computed(() => Trans.currentLocale)

// Inicializar región al montar
onMounted(() => {
  initializeRegion()
})

// Cambiar región
const changeRegion = (newRegionId) => {
  if (newRegionId === regionId.value) return
  
  setRegion(newRegionId)
  
  // Emitir evento para que el padre (App.vue) cierre el menú móvil
  emit('regionChanged')
}

// Cambiar idioma
const changeLanguage = async (locale) => {
  if (locale === currentLocale.value) return
  
  await Trans.switchLanguage(locale)
  
  // Track language change
  track('language_change', {
    from: currentLocale.value,
    to: locale,
    source: 'region_selector_mobile'
  })
  
  // Emitir evento para cerrar el menú móvil
  emit('regionChanged')
}
</script>

<style scoped>
.region-selector-mobile button {
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
</style>
